import { useCallback as y } from "react";
import { usePLMapboxStoreV2 as g } from "./index.es6.js";
import * as u from "@turf/turf";
const p = {
  maxZoom: 16,
  animate: !1
}, f = (t) => t.type === "FeatureCollection" ? t.features : t.type === "GeometryCollection" ? t.geometries.map((e) => ({
  type: "Feature",
  geometry: e,
  properties: {}
})) : t.type === "Feature" ? [t] : [{
  type: "Feature",
  geometry: t,
  properties: {}
}], F = (t, o = 250) => {
  const e = [];
  if (Array.isArray(t) ? t.forEach((r) => e.push(...f(r))) : t && e.push(...f(t)), e.length === 0) {
    console.warn("Empty features");
    return;
  }
  const i = e.map((r) => (r.geometry.type === "Point" || r.geometry.type === "MultiPoint") && u.buffer(r, o, {
    units: "feet"
  }) || r), n = u.bbox(u.featureCollection(i));
  return [
    n[0],
    n[1],
    n[2],
    n[3]
  ];
}, b = ({
  mapWidth: t,
  mapHeight: o
}) => {
  const e = o / 4, i = t / 4;
  return {
    top: e,
    bottom: e,
    left: i,
    right: i
  };
}, B = () => y(
  ({ mapId: t, features: o, bbox: e, pointBufferInFeet: i = 250, options: n = {} }) => {
    var c, m;
    const a = (m = (c = g.getState().maps) == null ? void 0 : c[t]) == null ? void 0 : m.mapRef;
    if (!a) {
      console.warn("wait for map to be initialized");
      return;
    }
    if (e) {
      a.fitBounds(e, {
        ...p,
        ...n
      });
      return;
    }
    const r = F(o, i);
    if (!r) {
      console.warn("No bounds calculated from features");
      return;
    }
    const s = a.getCanvas(), l = s.clientHeight, d = s.clientWidth;
    a.fitBounds(r, {
      ...p,
      padding: b({ mapWidth: d, mapHeight: l }),
      ...n
    });
  },
  []
);
export {
  F as getBBoxByFeatures,
  b as getPaddingOptions,
  B as useFitBounds
};
//# sourceMappingURL=index.es181.js.map
